import { render } from "./InventoryBalanceList.vue?vue&type=template&id=bdcd02ea&scoped=true"
import script from "./InventoryBalanceList.vue?vue&type=script&lang=js"
export * from "./InventoryBalanceList.vue?vue&type=script&lang=js"

import "./InventoryBalanceList.vue?vue&type=style&index=0&id=bdcd02ea&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdcd02ea"]])

export default __exports__